import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  ApHeaderBar,
  ApHeaderBarMenuIconTrigger,
  ApButtonIconWrapper,
  colors,
  ApMenuItem,
  ApMenuUser,
  ApHeaderBarDivider,
  ApButtonTab,
} from '@alixpartners/ui-components';
import {
  PERMISSIONS,
  hasSomeOfRequiredPermissions,
  SETTINGS_PERMISSIONS,
} from 'utils/constants';
import { ApAuthenticationContextConsumer } from '@alixpartners/ui-utils';
import get from 'lodash/get';
import { Notifications } from '../Notifications';
import { StyledLink } from './Header.styles';

interface IHeaderProps {
  //If permissions is undefined it is accessdenied page
  permissions?: string[];
}

interface IProps extends IHeaderProps {
  user?: any;
  logout?(): void;
}

const getInitials = (fullName: string) => {
  return fullName
    .split(' ')
    .map((n) => n[0])
    .join('');
};

const TABS = [
  { label: 'Spend', path: '/spend' },
  {
    label: 'Benchmarks',
    path: '/benchmarks',
    permission: PERMISSIONS.BENCHMARKS_ANALYSIS_READ,
  },
  { label: 'Applications', path: '/applications' },
  { label: 'Products', path: '/products' },
];

export const HeaderView: React.FC<IProps> = ({ user, permissions, logout }) => {
  const history = useHistory();
  const location = useLocation();
  let baseUrl = '/';

  try {
    const appUrls = JSON.parse(process.env.REACT_APP_URLS || '');
    baseUrl = appUrls.Main.Ui;
  } catch (e) {
    console.error('can not parse REACT_APP_URLS', e);
  }

  return (
    <ApHeaderBar
      application={{
        title: 'Tech Spend X-Ray',
        shortTitle: 'TXR',
        color: colors.red4,
        link: '/',
      }}
      baseUrl={baseUrl}
      rightMenu={() => (
        <React.Fragment>
          {permissions && (
            <React.Fragment>
              {TABS.map(({ label, path, permission }) => {
                if (permission && !permissions.includes(permission)) {
                  return null;
                }

                return (
                  <StyledLink exact to={path} title={label} key={path}>
                    <ApButtonTab
                      isSelected={location.pathname.indexOf(path) === 0}
                      theme="dark"
                    >
                      {label}
                    </ApButtonTab>
                  </StyledLink>
                );
              })}
              <ApHeaderBarDivider />
              <ApButtonIconWrapper theme="dark">
                <Notifications />
              </ApButtonIconWrapper>
              {hasSomeOfRequiredPermissions(
                permissions,
                SETTINGS_PERMISSIONS
              ) && (
                <ApHeaderBarMenuIconTrigger
                  theme="dark"
                  iconName="settings_outline"
                  onClick={function () {
                    history.push('/settings');
                  }}
                />
              )}
            </React.Fragment>
          )}

          <ApMenuUser
            initials={user ? getInitials(get(user, 'profile.name')) : ''}
          >
            {logout && <ApMenuItem onClick={logout}>Logout</ApMenuItem>}
          </ApMenuUser>
        </React.Fragment>
      )}
    />
  );
};

export const Header = (props: IHeaderProps) => (
  <ApAuthenticationContextConsumer>
    {({ user, logout }) => (
      <HeaderView user={user} logout={logout} {...props} />
    )}
  </ApAuthenticationContextConsumer>
);
